/**
 * documentFields — which inputs a document type actually has.
 *
 * Ported verbatim from the legacy presenter (`source/js/presenters/users-documents.js:152`),
 * where this map is a FRONTEND constant, not server data. That is worth
 * stating because the sibling certificate form drives the same idea from a
 * server-provided map: documents need no endpoint, certificates will.
 *
 * Keys are `documentTypes` ids as delivered in `window.serverData.documentTypes`.
 * A type missing from the map shows the name/type pair only.
 */
export const DOCUMENT_FIELDS = {
	2: { documentNumber: true },
	3: { documentNumber: true, dateOfIssue: true, dateExpires: true },
	4: { documentNumber: true },
	5: { documentNumber: true },
	6: { documentNumber: true, dateOfIssue: true, dateExpiresTSA: true },
	7: { documentNumber: true },
	8: {
		documentNumber: true,
		timeOfIssue: true,
		dateOfIssue: true,
		dateExpires: true,
		timeExpires: true,
		insuranceCompany: true
	},
	9: { doctorsName: true, dateOfIssue: true },
	10: { certificateNumber: true, dateOfIssue: true }
};

const EMPTY = {};

/** Field flags for a document type id (never null). */
export function fieldsForType(typeId) {
	if (typeId == null || typeId === '') return EMPTY;
	return DOCUMENT_FIELDS[Number(typeId)] || EMPTY;
}

export default DOCUMENT_FIELDS;
